import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StorageService } from '@core/services/util/storage.service';
import { UtilityService } from '@core/services/util/utility.service';

import { environment } from '@environment';
import { BehaviorSubject } from 'rxjs';
import { BottomStripApiResponse } from '@app/shared/models/api-response/bottom-strip-response';

@Injectable({
  providedIn: 'root'
})

export class CustomerApiService {

    creditBal: any = new BehaviorSubject<any>(null);
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private utilityService: UtilityService,
        private storageService: StorageService,
    ) {
        this.apiUrl = environment.apiUrl;
    }

    getRecommendedProducts() {

        const v2Headers = this.utilityService.getV2GlobalHeaders();
        const headers = {
            ...v2Headers,
            'Authorization': 'Bearer ' + this.storageService.get('session-id'),
        };

        return this.http.get(`${this.apiUrl}/v3/customer/recommended_products`, { headers });
    }

    getBottomStrips() {
        const v2Headers = this.utilityService.getV2GlobalHeaders();

        const params = {
            ver: 1
        };

        const headers = {
            ...v2Headers,
            'Authorization': 'Bearer ' + this.storageService.get('session-id'),
        };
        
        return this.http.get<BottomStripApiResponse>(`${this.apiUrl}/v5/customer/bottom_strip_details`, { params, headers });
    }

    fetchCreditBalance() {
        this.http.get(environment.c3pServiceUrl + "/customer_credit/balance", {
            headers: this.utilityService.getAuthHeaders("signed"),
        }).toPromise()
        .then((res: any) => {
            if (res && res.meta.code === 200) {
                this.creditBal.next(res.credit_balance);
            }
        }).catch((err: any) => console.log(err));
    }

    transactionBalance(type: any) {
        const params = {
            reason: type
        };
    
        return this.http.get(environment.c3pServiceUrl + "/customer_credit/get_transaction_balance", {
            params, headers: this.utilityService.getAuthHeaders("signed")
        }).toPromise();
    }

    getTicketDetails() {
        return this.http.get(this.apiUrl + "/third_party/yellow_ai/ticket", {
            headers: this.utilityService.getAuthHeaders("signed")
        });
    }

    referralContent() {
        return this.http.get(`https://assets.box8.co.in/referral/${environment.brand.id}/referral-content.json`).toPromise();
    }
}